import { ClassificationIcon, NoData, RenderWhen, Time } from "@components";
import { UrlReport } from "@modules/network/@types";
import ThirdPartyReputationStats from "@modules/network/components/common/ThirdPartyReputationStats";
import { UrlThreatIntelReason } from "@modules/network/mappings";
import { Schema } from "@modules/samples/@types/common";
import SearchLink from "@modules/search/components/links/SearchLink";

import NetworkLink from "../../common/components/NetworkLink";

export const schema: Schema<UrlReport> = {
  fields: [
    {
      name: "status",
      displayTitle: <ClassificationIcon />,
      className: "text-center",
      style: { padding: "10px", width: "3%" },
      component: ({ classification, threat_level }) => (
        <ClassificationIcon
          classification={classification}
          riskScore={threat_level}
        />
      )
    },
    {
      name: "url",
      displayTitle: "URL",
      style: { width: "36%" },
      component: ({ requested_url: url, classification }) => (
        <NetworkLink link={url} classification={classification} />
      )
    },
    {
      name: "last_analyzed",
      displayTitle: "Last Analyzed",
      style: { width: "15%" },
      component: ({ last_seen }) => (
        <RenderWhen condition={Boolean(last_seen)} fallback={<NoData />}>
          <Time time={last_seen} className="time-exact" withTitle />
        </RenderWhen>
      )
    },
    {
      name: "reason",
      displayTitle: "Classification Reason",
      style: { width: "15%" },
      component: ({ reason }) => (
        <RenderWhen condition={Boolean(reason)} fallback={<NoData />}>
          <UrlThreatIntelReason reason={reason} />
        </RenderWhen>
      )
    },
    {
      name: "threat",
      displayTitle: "Threat",
      className: "overflow-ellipsis",
      style: { width: "21%", padding: "10px" },
      component: ({ threat_name: threatName }) => (
        <RenderWhen condition={Boolean(threatName)} fallback={<NoData />}>
          <SearchLink
            className="underline"
            keyword="THREATNAME"
            value={threatName ?? ""}
            data-testid="ip-related-urls-threat-link"
          >
            {threatName}
          </SearchLink>
        </RenderWhen>
      )
    },
    {
      name: "detections",
      displayTitle: "Detections",
      style: { width: "10%" },
      component: ({ third_party_reputations: { statistics } = {} }) => (
        <ThirdPartyReputationStats
          className="flex w-100 justify-content-start"
          maliciousCount={statistics?.malicious}
          totalCount={statistics?.total}
        />
      )
    }
  ]
};
